import React from 'react'
import { colors } from '../../../styles/vars/colors.style'

const Route1 = ({
  width = 448,
  height = 486,
  stroke = colors.light,
  opacity = 1,
  offset = false,
  pathLength = 1394,
  responsive = true,
  forwardRef = null,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 486"
      focusable="false"
      role="img"
      fill="none"
      {...svgAttributes}
    >
      <path
        strokeWidth="3"
        stroke={stroke}
        opacity={opacity}
        ref={forwardRef}
        strokeDashoffset={offset ? pathLength : 0}
        strokeDasharray={pathLength}
        d="M170.5,1.5C163,3 155,8 157,25C160.094,51.2951 219,71 258,71C297,71 339,96 346,116C353,136 366,140 400,150C434,160 444,174 446,197C448,220 422,274 357,320C305,356.8 306.667,393.333 314,407C316.333,413.333 316.8,427.8 300,435C279,444 254,497 285,482C309.8,470 286.667,463 272,461C250.667,457 207.2,441.8 204,413C200,377 210,357 219,307C228,257 216,249 195,226C174,203 171,176 168,140C165,104 130,89 80,71C40,56.6 10.6667,29 1,17"
      />
    </svg>
  )
}

export default Route1
